<template>
  <div>
    <div class="groupList">
      <div class="item" v-for='(i,k) in showData' :key='k' @click="lawerDetail(i, k)">
        <div class="avt">
          <img :src="i.cover" alt="">
        </div>
        <div class="des">
          <div style="display: flex">
          <p class="name">{{i.name}}</p>
<!--          <p class="id">{{idName}}</p>-->
          <p class="address">{{i.eliteEnumId==1?getIndexData.fixedFieldMap['elite.partner']:getIndexData.fixedFieldMap['elite.lawyer']}}</p>
          </div>
          <div class="phone">
            <i class="iconfont icon-youxiang"></i>
            <span>{{i.email}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--        <div class="nomore" v-show='!data.length'>暂无更多</div>-->
    <div class="page">
      <i class="left iconfont icon-youjiantou" @click="prePage()"></i>
      <div class="item" :class="{active: current===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>
        <div @click="currentPage(k)">{{k+1}}</div>
      </div>
      <i class="right iconfont icon-youjiantou" @click="nextPage()"></i>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
  export default {
    components: {},
    props: {
      data: Array,
      idName: String,
    },
    computed: {
      ...mapGetters(['getIndexData']),
    },
    data() {
      return {
        showData: [],
        total: this.data.length,
        size: 4,
        current: 0
      }
    },
    created() {
      this.currentPage(0);
    },
    methods: {
      order() {
        console.log("showData", this.showData)
      },
      lawerDetail(i) {
        this.$router.push('/elite/lawerDetail/' + i.id + '?cover=' + i.cover)
        document.documentElement.scrollTop = 0
      },
      nextPage() {
        if (this.current + 1 == Math.ceil(this.total / this.size)) {
        } else {
          this.current = this.current + 1;
        }
      },
      // 上一页
      prePage() {
        if (this.current == 0) {
        } else {
          this.current = this.current - 1;
        }
      },
      // 点击页码
      currentPage(i) {
        this.current = i;
        this.watch
      }
    },
    watch: {
      data: function (newData, oldData) {
        console.log("order", newData)  //newData就是orderData
        this.total = newData.length;
        this.showData = newData.slice(this.current * this.size, (this.current + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
        this.order();
      },
      current: function (newData, oldData) {
        console.log("current", newData)  //newData就是orderData
        this.showData = this.data.slice(newData * this.size, (newData + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
        this.order();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"
  theme = #f7aa05


  .groupList
    _flex()
    flex-wrap wrap

    .nomore
      pt(60)
      box()
      ta(center)
      flex 1
      h(280)
      bg(#fff)
      fs(14)
      c(gray)

    .item
      _hover()
      width 25%
      h(240)
      mb(80)
      mt(30)

      .avt
        height 236px
        width 173px
        ib()

    img
      wh()

  .des
    pl(0)
    box()
    hh()
    ib()
    width 100%
    height 30%
    va(top)

    .name
      fs(17)
      width 50%

    .id
      fs(14)
      c(gray)

    .address
      fs(14)
      c(theme)

    .phone
      word-break break-all

      i
        fs(14)
        pr(10)

      span
        fs(13)


  theme = #f7aa05

  .page
    ta(center)
    fs(0)

    .item
      ib()
      w(40)
      h(30)
      ml(10)
      mr(10)
      va(middle)
      fs(17)
      lh(30)
      c(gray)
      _hover()

      &.active
        bg(theme)
        c(#fff)

    .left
      fs(15)
      c(gray)
      ib()
      transform rotate(180deg)
      vertical-align -4px
      mr(10)

      &:hover
        cursor pointer

    .right
      &:hover
        cursor pointer
      ml(10)
      va(middle)
      c(gray)
      fs(15)

</style>



// WEBPACK FOOTER //
// src/components/elite/groupList.vue